import messages from '@intlify/unplugin-vue-i18n/messages'
import axios from 'axios'
import { locale as setLocale } from 'dayjs'
import 'dayjs/locale/da'
import 'dayjs/locale/de'
import 'dayjs/locale/en'
import 'dayjs/locale/sv'
import 'dayjs/locale/nb'
import 'dayjs/locale/pl'
import 'dayjs/locale/hu'
import 'dayjs/locale/it'
import 'dayjs/locale/fr'
import 'dayjs/locale/ro'
import { createI18n } from 'vue-i18n'

export interface Locale {
    flag: string
    name: string
}

export const locales: Record<string, Locale> = {
    en: { flag: 'us', name: 'English' },
    da: { flag: 'dk', name: 'Dansk' },
    de: { flag: 'de', name: 'Deutsch' },
    no: { flag: 'no', name: 'Norsk' },
    sv: { flag: 'se', name: 'Svenska' },
    it: { flag: 'it', name: 'Italiano' },
    fr: { flag: 'fr', name: 'Français' },
    hu: { flag: 'hu', name: 'Magyar' },
    pl: { flag: 'pl', name: 'Polski' },
    cs: { flag: 'cz', name: 'Czech' },
    ro: { flag: 'ro', name: 'Română' },
}
const currentLocale = getLanguage()
export const i18n = createI18n({
    locale: currentLocale,
    fallbackLocale: 'ro',
    legacy: false,
    silentFallbackWarn: true,
    messages,
})

setLocale(currentLocale === 'no' ? 'nb' : currentLocale)

// TODO: Re-add lazy loading of translations
export async function setI18nLanguage(locale: string) {
    i18n.global.locale.value = locale
    localStorage.setItem('language', locale)
    document.querySelector('html')!.setAttribute('lang', locale)
    setLocale(locale === 'no' ? 'nb' : locale)
    if (window.user) {
        await axios.put(window.route('locale.update', { locale }))
    }
}

function getLanguage(): string {
    // Prefer explicitly saved per-user and local storage
    if (window.user?.locale) return window.user.locale
    if (localStorage.getItem('language')) return localStorage.getItem('language')!

    const browserLanguage = (navigator.language || '').split('-')[0]
    if (browserLanguage) return browserLanguage

    // Default to Romanian when nothing else is set
    return 'ro'
}
